import React from 'react'
import Breadcrumbs from '../Breadcrumbs'
import Footer from '../Footer'
import embarque from '../../assets/images/desembarque/desembarque-auto.png'

export default function ViajasConVehiculo() {
  return (
     <section className='info-documentacion'>
        <div className='container'>
            <Breadcrumbs />
            <div>
                <div className='recomendaciones-para-viajar'>
                    <div className='recomendaciones-para-viajar-title'>
                        <h1>¿Estás listo para zarpar?</h1>              

                        <label>Tips para mejorar tu experiencia</label>
                        <p>Una gran ventaja de llevar tu auto es que dentro del mismo puedes llevar todo el equipaje que requieras.</p>
                        <p>* Cómo vehículos se consideran aquellos autos de uso personal o familiares. </p>
                    </div>
                    <div className='recomendaciones-para-viajar-box'>
                        <div><i>1.</i> <strong>Llega</strong> al puerto con 2 h de antelación.</div>
                        <div><i>3.</i> <strong>Mantén</strong> tu pase deabordar a la mano. En QR o impreso.</div>
                        <div><i>2.</i> <strong>Cruza</strong> los filtros de seguridad.</div>
                        <div><i>4.</i> <strong>Haz</strong> uso de nuestro autobús para abordar.</div>
                    </div>
                </div>

                <div className='recomendaciones-para-viajar'>
                    <div>
                        <img src={embarque} alt='' />
                    </div>
                    <div>
                       <h2>¿Llevas auto?</h2> 
                       <label>¡Prepara tu documentación!</label>
                       <ul>
                            <li>Factura (original o copia)</li>
                            <li>Tarjeta de circulación</li>
                            <li>Póliza de seguro vigente</li>
                            <li>Licencia de conducir e identificación oficial con fotografía</li>
                       </ul>
                       <label>* Si tu vehículo es fronterizo, lleva tu pedimento de importación.</label>

                    </div>
                </div>

                <div className='recomendaciones-para-viajar'>
                    <div className='recomendaciones-para-viajar-title'>
                        <h2>Tips para mejorar tu experiencia</h2>
                    </div>
                    <div className='recomendaciones-para-viajar-box'>
                        <div>1. Pasa a revisión de las autoridades. <br /> En el Puerto de Pichilingue cruzarás aduana. Si llevas artículos nuevos, trae contigo sus facturas.</div>
                        <div>2. En aforo te solicitarántu pase de abordar a lamano. En QR o impreso.</div>
                        <div>3. Dirígete a báscula. Deberás pagar la aportación quete indique la autoridad. <br/> Se acepta efectivo o tarjeta.</div>
                        <div>4. Nuestro personal te indicará elárea de espera y te indicará elmomento para embarcar.</div>
                    </div>
                </div>

                <ul>
                    <li>Si tus acompañantes son mayores de edad, deben hacer check-in como pasajeros a pie dentro de la terminal donde un autobús los abordará.</li>
                    <li>Si viajas con menores de edad o adultos mayores podrán permanecer en el automóvil y abordar contigo.</li>                          
                </ul>
            </div>

            <div className='recomendaciones-para-abordar'>
                <div className='recomendaciones-para-viajar-title'>
                    <h2>Sobre tu equipaje...</h2>                                      
                </div>
                <div className='recomendaciones-abordar'>
                    <div style={{display:'flex'}}>
                        <div>
                            <label>A bordo:</label>
                            <ul className='permitido-abordo'>
                                <li><i class="fi fi-sr-check-circle"></i> Artículo personal</li>
                                <li><i class="fi fi-sr-check-circle"></i> Maleta de mano</li>
                                <label>Hasta 10 kg</label>                        
                            </ul>
                            <label>Documentado:</label>
                            <ul className='permitido-abordo'>
                                <li><i class="fi fi-sr-check-circle"></i> 5 maletas adicionales sin costo.</li>
                                <label>Hasta 25 kg</label>                        
                            </ul>
                            <label>¡Conserva tu comprobante de reclamo!</label>  
                        </div>
                        <div>
                            <label>No abordes con:</label>
                            <ul>
                                <li><i class="fi fi-sr-cross-circle"></i> Alimentos</li>
                                <li><i class="fi fi-sr-cross-circle"></i> Bebidas</li>
                                <li><i class="fi fi-sr-cross-circle"></i> Almohadas</li>
                                <li><i class="fi fi-sr-cross-circle"></i> Cobijas</li> 
                                <label>¡Documéntalo!</label>                           
                            </ul>
                        </div>
                  
                    </div> 
                    <label>* Si superas el peso, Baja Ferries no podrá hacerse responsable del manejo y posibles daños.</label>
                   
                </div>
                        
            </div>

        </div>
        <Footer />
    </section>
  )
}
